module.exports = __webpack_public_path__ + "img/35fdb62942f534169e00e27fb1f47001.png";